export default "__VITE_ASSET__BOGX4lg6__"